import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { ScrollbarModule } from 'src/@fury/shared/scrollbar/scrollbar.module';

import { AvatarDisplayModule } from 'src/app/modules/avatar/avatar-display/avatar-display.module';
import { UserClientFormAutoCompleteModule } from 'src/app/generated/ui/chipList/UserClient/UserClient.module';

import { ChatDashboardComponent } from './dashboard.component';
import { ChatMessageModule } from '../message/message.module';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  declarations: [ChatDashboardComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,

    MatFormFieldModule,
    MatListModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatIconModule,
    MatBadgeModule,
    ScrollbarModule,

    AvatarDisplayModule,
    UserClientFormAutoCompleteModule,
    ChatMessageModule
  ],
  exports: [ChatDashboardComponent]
})
export class ChatDashboardModule {}
